import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { InscripcionFormComponent } from './inscripcion-form/inscripcion-form.component';
import { LayoutProveedoresComponent } from './layout-proveedores/layout-proveedores.component';

const routes: Routes = [
  // { path: '', redirectTo: '/proveedores', pathMatch: 'full' },
  // { path: 'proveedores', component: HomeComponent },
  // { path: 'inscription', component: InscripcionFormComponent }
  {
    path: '',
    component: LayoutProveedoresComponent,
    children: [
      { path: '', component: HomeComponent },
      { path: 'inscription', component: InscripcionFormComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProveedorRoutingModule { }
